// Module
var code = "<title>Customily</title> <div style=\"min-height:100%\" ng-controller=\"StampCtrl\"></div> ";
// Exports
module.exports = code;